import { ScriptAnalysis } from '../../../types';

export function shouldPollAnalysisStatus(status: ScriptAnalysis['status'] | undefined): boolean {
  return status === 'analyzing' ||
    status === 'generating_prompts' ||
    status === 'pending_normalization' ||
    status === 'cancelling';
}
